<template lang="pug">
    m-list-effectiveness(:items="items" :assessmentId="assessmentId")
</template>

<script>
    import MListEffectiveness from "@modules/lists/concrete/m-list-effectiveness";
    import {questions, possibleQuestionAnswers, possibleEvaluationsAnswers} from "@constants/common";

    export default {
        name: "m-block-content-effectiveness-assessment-items",
        components: {MListEffectiveness},
        props: {
            assessment: {
                type: Array,
                required: true
            },
            configuration: {
                type: Array,
                required: true
            },
            assessmentId: {
                type: String,
            },
        },
        computed: {
            items() {
                let items = [];
                this.configuration.forEach((section, sectionIndex) => {
                    section.children.forEach((question, questionIndex) => {
                        items = items.concat(this.checkEvaluations(question, this.assessment[sectionIndex].children[questionIndex]));
                    });
                });

                return this.$lodash.orderBy(items, ['answer', 'title'], ['desc', 'asc']);
            }
        },
        methods: {
            checkEvaluations(question, answer) {
                if (question.type === questions.types.notice
                    || (question.type !== questions.types.evaluation
                        && !!answer && (answer.answer === possibleQuestionAnswers.no))
                ) {
                    return [];
                }

                if (question.type === questions.types.evaluation) {
                    if (!!answer && !!answer.answer && answer.answer !== 'yes'
                    ) {
                        return [{
                            ...question,
                            answer: answer,
                            key: question.title + '-' + this.$t('modules.blocks.m-block-effectiveness-actions.evaluation.patterns.' + answer.answer)
                        }];
                    } else {
                        return [];
                    }
                } else {
                    let result = [];
                    question.children.map((child, childIndex) => {
                        if (!!answer) result = result.concat(this.checkEvaluations(child, answer.children[childIndex]));
                    });
                    return result.sort((a, b) => {
                        return a.title - b.title;
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>
